import { api } from './client';

export interface QuoteItem {
  product_id: string;
  quantity: number;
  notes?: string;
}

export interface QuoteRequest {
  id: number;
  user_id: number | null;
  items: QuoteItem[];
  form_data: Record<string, string>;
  status: 'pending' | 'reviewed' | 'accepted' | 'rejected';
  notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface CreateQuoteRequest {
  items: QuoteItem[];
  form_data?: Record<string, string>;
}

export const quotesApi = {
  createQuote: (data: CreateQuoteRequest) =>
    api.post<QuoteRequest>('/quotes/', data),

  getQuotes: () =>
    api.get<QuoteRequest[]>('/quotes/'),

  getQuote: (id: number) =>
    api.get<QuoteRequest>(`/quotes/${id}/`),

  updateQuoteStatus: (id: number, status: string, notes?: string) =>
    api.patch<QuoteRequest>(`/quotes/${id}/status/`, { status, notes }),
};
